import { readItem } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import type { Event } from '../../../../types/DirectusSchema';
import { directusClient } from '../../services/directusClient/directusClient.ts';
import { parseEvent } from '../lib/parseEvent.ts';

export const useEventsItemQuery = (key?: string) =>
  useQuery({
    enabled: !!key,
    queryKey: ['events', key],
    queryFn: async () => {
      const result = await directusClient.request(
        readItem('events', key ?? '', {
          fields: [
            '*',
            {
              venue: ['id', 'commercial_name'],
              category: ['id', 'title'],
              target_audiences: ['id', { target_audiences_id: ['*'] }],
              event_details: ['id', { event_details_id: ['*'] }],
            },
          ],
        }),
      );

      return parseEvent(result as unknown as Event);
    },
  });
